import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { CustomPage } from '../models/customPage';

export class CustomPageService extends BaseService<CustomPage> {
  override model = CustomPage;
  override modelName = 'customPage';
  override modelLabel = 'Custom Page';

  async saveCustomPage(
    customPage: CustomPage,
    { publish = false }: { publish?: boolean } = {},
  ): Promise<ApiResponse<CustomPage>> {
    const isNew = customPage.isNewRecord;

    const request = new ApiRequest({
      method: isNew ? 'POST' : 'PUT',
      url: isNew
        ? this.modelBaseUrl
        : `${this.modelBaseUrl}/${customPage.objectID()}`,
      data: customPage.toJSON(),
      query: { publish: publish ? '1' : '0' },
    });

    return await this.requestItem(request, CustomPage);
  }
}
